<template>
    <div class="flex flex-col overflow-hidden">
        <wizard-steps v-if="showSteps"></wizard-steps>
        <wizard-content>
            <transition name="slide-fade" mode="out-in" appear>
                <router-view></router-view>
            </transition>
        </wizard-content>
        <portal-target name="contact-question-banner"></portal-target>
    </div>
</template>

<script>
import WizardContent from './WizardContent.vue';
import WizardSteps from './WizardSteps'

export default {
    components: {
        WizardSteps,
        WizardContent
    },

    computed: {
        showSteps() {
            return this.$store.state.ui.showSteps;
        }
    },
}
</script>

<style>
</style>
